import { render, staticRenderFns } from "./ActionUser.vue?vue&type=template&id=527b2160&"
import script from "./ActionUser.vue?vue&type=script&lang=ts&"
export * from "./ActionUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports